<div class="image-modal-backdrop" *ngIf="isVisible" @fadeIn (click)="onBackdropClick($event)">
    <div class="image-modal-container" @zoomIn>
        <!-- Close Button -->
        <button class="modal-close-btn" (click)="close()">
            <i class="fa-solid fa-xmark"></i>
        </button>

        <!-- Image Counter -->
        <div class="image-counter" *ngIf="hasMultipleImages">
            {{ currentIndex + 1 }} / {{ images.length }}
        </div>

        <!-- Previous Button -->
        <button class="nav-btn prev-btn" *ngIf="hasMultipleImages && canGoPrev" (click)="prev()">
            <i class="fa-solid fa-chevron-left"></i>
        </button>

        <!-- Main Image -->
        <div class="image-wrapper" [class.zoomed]="isZoomed" (click)="toggleZoom()">
            <img [src]="currentImage" [alt]="alt" [class.zoomed]="isZoomed" />
        </div>

        <!-- Next Button -->
        <button class="nav-btn next-btn" *ngIf="hasMultipleImages && canGoNext" (click)="next()">
            <i class="fa-solid fa-chevron-right"></i>
        </button>

        <!-- Thumbnail Navigation -->
        <div class="thumbnail-nav" *ngIf="hasMultipleImages">
            <div class="thumbnail"
                 *ngFor="let img of images; let i = index"
                 [class.active]="i === currentIndex"
                 (click)="goToImage(i); $event.stopPropagation()">
                <img [src]="img" [alt]="'Thumbnail ' + (i + 1)" />
            </div>
        </div>

        <!-- Zoom Hint -->
        <div class="zoom-hint">
            <i class="fa-solid" [ngClass]="isZoomed ? 'fa-magnifying-glass-minus' : 'fa-magnifying-glass-plus'"></i>
            {{ isZoomed ? 'Click to zoom out' : 'Click to zoom in' }}
        </div>
    </div>
</div>
